export const getTotalQuantity = (products) =>
  products.reduce((acc, el) => {
    return acc + el.qty;
  }, 0);

export const getTotalPrice = (products, showVAT) =>
  products.reduce(
    (acc, el) =>
      acc +
      (showVAT ? parseFloat(el.item.price) : parseFloat(el.item.priceNoVat)) *
        el.qty,
    0
  );
